import GoogleMapsLoader from 'google-maps'
import styles from '../map-styles.json'

GoogleMapsLoader.VERSION = 'weekly'
GoogleMapsLoader.KEY = 'AIzaSyAvKRwNYqSy-BxsXlGmGtCZ1DO4rwF9S8c'

export default function map ($el, { lat, lng, markerImage }) {
  GoogleMapsLoader.load(google => {
    let map = new google.maps.Map($el, {
      center: { lat, lng },
      zoom: 16,
      styles
    })

    let marker = new google.maps.Marker({
      map,
      position: { lat, lng },
      icon: {
        url: markerImage,
        size: new google.maps.Size(56, 78),
        scaledSize: new google.maps.Size(56, 78),
        anchor: new google.maps.Point(28, 76)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/js/components/map.js